import { StageDefinition } from './StageDefinition';

export const stage16: StageDefinition = {
    platforms: [
        [46.45161290322581, 0],
        [127.74193548387095, 0],
        [123.1578947368421, 1],
        [122.72727272727276, 2],
        [64.80000000000001, 3],
        [122.40000000000003, 3],
        [345.5999999999997, 3],
        [119.99999999999997, 4],
        [183.15789473684214, 4],
        [208.42105263157902, 4],
        [214.73684210526324, 4],
        [221.05263157894746, 4],
        [227.36842105263167, 4],
        [233.6842105263159, 4],
        [258.9473684210528, 4],
        [265.263157894737, 4],
        [271.5789473684212, 4],
        [277.89473684210543, 4],
        [284.21052631578965, 4],
        [347.36842105263185, 4],
        [119.99999999999994, 5],
        [182.85714285714286, 5],
        [348.5714285714288, 5],
        [78.2608695652174, 6],
        [120.00000000000003, 6],
        [182.60869565217382, 6],
        [349.56521739130386, 6],
        [119.99999999999996, 7],
        [182.4000000000001, 7],
        [350.4000000000005, 7],
        [118.53658536585367, 8],
        [184.3902439024389, 8],
        [351.2195121951213, 8],
        [94.09090909090912, 9],
        [98.18181818181822, 9],
        [102.27272727272731, 9],
        [106.3636363636364, 9],
        [110.4545454545455, 9],
        [114.54545454545459, 9],
        [118.63636363636368, 9],
        [184.09090909090918, 9],
        [188.18181818181827, 9],
        [192.27272727272737, 9],
        [196.36363636363646, 9],
        [200.45454545454555, 9],
        [204.54545454545465, 9],
        [208.63636363636374, 9],
        [212.72727272727283, 9],
        [216.81818181818193, 9],
        [220.90909090909102, 9],
        [225.0000000000001, 9],
        [229.0909090909092, 9],
        [233.1818181818183, 9],
        [237.2727272727274, 9],
        [241.3636363636365, 9],
        [245.45454545454558, 9],
        [249.54545454545467, 9],
        [253.63636363636377, 9],
        [257.72727272727286, 9],
        [261.8181818181819, 9],
        [265.909090909091, 9],
        [270.00000000000006, 9],
        [274.0909090909091, 9],
        [278.1818181818182, 9],
        [282.27272727272725, 9],
        [286.3636363636363, 9],
        [290.4545454545454, 9],
        [294.54545454545445, 9],
        [298.6363636363635, 9],
        [302.7272727272726, 9],
        [306.81818181818164, 9],
        [310.9090909090907, 9],
        [314.9999999999998, 9],
        [319.09090909090884, 9],
        [323.1818181818179, 9],
        [327.27272727272697, 9],
        [331.36363636363603, 9],
        [335.4545454545451, 9],
        [339.54545454545416, 9],
        [343.6363636363632, 9],
        [347.7272727272723, 9],
        [351.81818181818136, 9],
        [355.9090909090904, 9],
    ],
    traps: [
        [81.29032258064515, 0],
        [139.3548387096774, 0],
        [150.96774193548387, 0],
        [162.58064516129033, 0],
        [220.64516129032265, 0],
        [101.05263157894736, 4],
        [290.52631578947387, 4],
        [307.82608695652135, 6],
        [289.75609756097515, 8],
    ],
    stars: [
        [336, 5],
        [204, 10],
        [323, 10],
        [259, 10],
        [96, 5],
    ],
};
